import { useDispatch } from 'react-redux';
import { useEffect } from 'react';

import { Header } from '@app/sections/header';
import { Strings } from '@app/constants';
import { useDialog, useRequestState, useSearch } from '@app/hooks';
import { useTable } from '@app/components/table';
import { InternList } from './intern-list';
import { getInterns } from '../slice';
import { selectInternState } from '../selectors';
import { AddEmployeePage } from '@app/modules/employees';

const InternListPage = () => {
  const tableProps = useTable();
  const internDialog = useDialog();

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getInterns());
  }, [dispatch]);

  const { data, loading } = useRequestState({
    stateSelector: selectInternState,
    errorShown: true,
  });
  const searchProps = useSearch({
    data,
    fields: ['firstName', 'lastName', 'email', 'phone', 'id'],
  });

  return (
    <>
      <Header
        title={Strings.page_title.interns}
        helperText={''}
        actionButtonTitle={Strings.button.addIntern}
        onClickActionButton={internDialog.show}
        searchBarProps={{
          placeholder: Strings.common.idNameEmailPhone,
          onChange: searchProps.handleSearchChange,
        }}
      />
      <InternList tableProps={tableProps} rows={searchProps.filteredRows} loading={loading} />
      {internDialog.visible && (
        <AddEmployeePage open onClose={internDialog.hide} title={'intern'} showInternRole />
      )}
    </>
  );
};

export { InternListPage };
